/**
 * Check image load
 */
export function checkImage(imageSrc) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = reject;
    img.src = imageSrc;
  });
}



// WEBPACK FOOTER //
// ./src/helpers/checkImage.ts